var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('statistics-vue'),_c('abnormal-vue'),_c('order-vue'),_c('order1-vue'),_c('line-graph-vue'),_c('line-graph-1-vue')],1)}
var staticRenderFns = []

export { render, staticRenderFns }